<template>
    <div class="product-categories">
        <section class="product classic" v-if="$route.params.product === this.$parent.products.classic.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.classic.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.classic.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.classic.descriere"></div>
                <h3>{{ this.$parent.products.classic.titlu_culori }}</h3>
                <ul class="product-colors">
                    <li v-for="color in this.$parent.products.classic.culori" :key="color.id">
                        <img :src="color.imgSrc" :alt="color.numeCuloare">
                        <span>{{ color.numeCuloare }}</span>
                    </li>
                </ul>
                <h3>{{ this.$parent.products.classic.info_technice.titlu }}</h3>
                <div class="product-info">
                    <div class="product-info__images">
                        <img :src="this.$parent.products.classic.info_technice.img_1.src" :alt="this.$parent.products.classic.info_technice.img_1.alt">
                        <img :src="this.$parent.products.classic.info_technice.img_2.src" :alt="this.$parent.products.classic.info_technice.img_2.alt">
                    </div>
                    <div class="product-info__specifications" v-html="this.$parent.products.classic.info_technice.specificatii"></div>
                </div>
                <div class="product-links">
                    <a :href="this.$parent.products.classic.pliant.href" target="_blank">
                        Descarca pliantul
                        <img :src="this.$parent.products.classic.pliant.src" :alt="this.$parent.products.classic.pliant.alt">
                    </a>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL CLASSIC -->

        <section class="product heritage" v-if="$route.params.product === this.$parent.products.heritage.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.heritage.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.heritage.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.heritage.descriere"></div>
                <h3>{{ this.$parent.products.heritage.titlu_culori }}</h3>
                <ul class="product-colors">
                    <li v-for="color in this.$parent.products.heritage.culori" :key="color.id">
                        <img :src="color.imgSrc" :alt="color.numeCuloare">
                        <span>{{ color.numeCuloare }}</span>
                    </li>
                </ul>
                <h3>{{ this.$parent.products.heritage.info_technice.titlu }}</h3>
                <div class="product-info">
                    <div class="product-info__images">
                        <img :src="this.$parent.products.heritage.info_technice.img_1.src" :alt="this.$parent.products.heritage.info_technice.img_1.alt">
                        <img :src="this.$parent.products.heritage.info_technice.img_2.src" :alt="this.$parent.products.heritage.info_technice.img_2.alt">
                    </div>
                    <div class="product-info__specifications" v-html="this.$parent.products.heritage.info_technice.specificatii"></div>
                </div>
                <div class="product-links">
                    <a :href="this.$parent.products.heritage.pliant.href" target="_blank">
                        Descarca pliantul
                        <img :src="this.$parent.products.heritage.pliant.src" :alt="this.$parent.products.heritage.pliant.alt">
                    </a>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL HERITAGE -->

        <section class="product milano" v-if="$route.params.product === this.$parent.products.milano.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.milano.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.milano.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.milano.descriere"></div>
                <h3>{{ this.$parent.products.milano.titlu_culori }}</h3>
                <ul class="product-colors">
                    <li v-for="color in this.$parent.products.milano.culori" :key="color.id">
                        <img :src="color.imgSrc" :alt="color.numeCuloare">
                        <span>{{ color.numeCuloare }}</span>
                    </li>
                </ul>
                <h3>{{ this.$parent.products.milano.info_technice.titlu }}</h3>
                <div class="product-info">
                    <div class="product-info__images">
                        <img :src="this.$parent.products.milano.info_technice.img_1.src" :alt="this.$parent.products.milano.info_technice.img_1.alt">
                        <img :src="this.$parent.products.milano.info_technice.img_2.src" :alt="this.$parent.products.milano.info_technice.img_2.alt">
                    </div>
                    <div class="product-info__specifications" v-html="this.$parent.products.milano.info_technice.specificatii"></div>
                </div>
                <div class="product-links">
                    <a :href="this.$parent.products.milano.pliant.href" target="_blank">
                        Descarca pliantul
                        <img :src="this.$parent.products.milano.pliant.src" :alt="this.$parent.products.milano.pliant.alt">
                    </a>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL MILANO -->

        <section class="product shake" v-if="$route.params.product === this.$parent.products.shake.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.shake.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.shake.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.shake.descriere"></div>
                <h3>{{ this.$parent.products.shake.titlu_culori }}</h3>
                <ul class="product-colors">
                    <li v-for="color in this.$parent.products.shake.culori" :key="color.id">
                        <img :src="color.imgSrc" :alt="color.numeCuloare">
                        <span>{{ color.numeCuloare }}</span>
                    </li>
                </ul>
                <h3>{{ this.$parent.products.shake.info_technice.titlu }}</h3>
                <div class="product-info">
                    <div class="product-info__images">
                        <img :src="this.$parent.products.shake.info_technice.img_1.src" :alt="this.$parent.products.shake.info_technice.img_1.alt">
                        <img :src="this.$parent.products.shake.info_technice.img_2.src" :alt="this.$parent.products.shake.info_technice.img_2.alt">
                    </div>
                    <div class="product-info__specifications" v-html="this.$parent.products.shake.info_technice.specificatii"></div>
                </div>
                <div class="product-links">
                    <a :href="this.$parent.products.shake.pliant.href" target="_blank">
                        Descarca pliantul
                        <img :src="this.$parent.products.shake.pliant.src" :alt="this.$parent.products.shake.pliant.alt">
                    </a>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL SHAKE -->

        <section class="product shingle" v-if="$route.params.product === this.$parent.products.shingle.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.shingle.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.shingle.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.shingle.descriere"></div>
                <h3>{{ this.$parent.products.shingle.titlu_culori }}</h3>
                <ul class="product-colors">
                    <li v-for="color in this.$parent.products.shingle.culori" :key="color.id">
                        <img :src="color.imgSrc" :alt="color.numeCuloare">
                        <span>{{ color.numeCuloare }}</span>
                    </li>
                </ul>
                <h3>{{ this.$parent.products.shingle.info_technice.titlu }}</h3>
                <div class="product-info">
                    <div class="product-info__images">
                        <img :src="this.$parent.products.shingle.info_technice.img_1.src" :alt="this.$parent.products.shingle.info_technice.img_1.alt">
                        <img :src="this.$parent.products.shingle.info_technice.img_2.src" :alt="this.$parent.products.shingle.info_technice.img_2.alt">
                    </div>
                    <div class="product-info__specifications" v-html="this.$parent.products.shingle.info_technice.specificatii"></div>
                </div>
                <div class="product-links">
                    <a :href="this.$parent.products.shingle.pliant.href" target="_blank">
                        Descarca pliantul
                        <img :src="this.$parent.products.shingle.pliant.src" :alt="this.$parent.products.shingle.pliant.alt">
                    </a>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL SHINGLE -->

        <section class="product diamant" v-if="$route.params.product === this.$parent.products.diamant.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.diamant.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.diamant.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.diamant.descriere"></div>
                <h3>{{ this.$parent.products.diamant.titlu_culori }}</h3>
                <ul class="product-colors">
                    <li v-for="color in this.$parent.products.diamant.culori" :key="color.id">
                        <img :src="color.imgSrc" :alt="color.numeCuloare">
                        <span>{{ color.numeCuloare }}</span>
                    </li>
                </ul>
                <h3>{{ this.$parent.products.diamant.info_technice.titlu }}</h3>
                <div class="product-info">
                    <div class="product-info__images">
                        <img :src="this.$parent.products.diamant.info_technice.img_1.src" :alt="this.$parent.products.diamant.info_technice.img_1.alt">
                        <img :src="this.$parent.products.diamant.info_technice.img_2.src" :alt="this.$parent.products.diamant.info_technice.img_2.alt">
                    </div>
                    <div class="product-info__specifications" v-html="this.$parent.products.diamant.info_technice.specificatii"></div>
                </div>
                <div class="product-links">
                    <a :href="this.$parent.products.diamant.pliant.href" target="_blank">
                        Descarca pliantul
                        <img :src="this.$parent.products.diamant.pliant.src" :alt="this.$parent.products.diamant.pliant.alt">
                    </a>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL DIAMANT -->

        <section class="product alpine" v-if="$route.params.product === this.$parent.products.alpine.nume.toLowerCase().split(' ').join('-')">
            
            <agile :options="options">
              <div class="slide" v-for="slide in this.$parent.products.alpine.carousel" :key="slide.id">
                <img :src="slide.imgSrc" :alt="slide.imgAlt">
              </div>
            </agile>

            <div class="product-inner">
                <h2 class="product-title">{{ this.$parent.products.alpine.nume }}</h2>
                <div class="product-description" v-html="this.$parent.products.alpine.descriere"></div>
                <h3>{{ this.$parent.products.alpine.titlu_culori }}</h3>
                <ul class="product-colors">
                    <li v-for="color in this.$parent.products.alpine.culori" :key="color.id">
                        <img :src="color.imgSrc" :alt="color.numeCuloare">
                        <span>{{ color.numeCuloare }}</span>
                    </li>
                </ul>
                <h3>{{ this.$parent.products.alpine.info_technice.titlu }}</h3>
                <div class="product-info">
                    <div class="product-info__images">
                        <img :src="this.$parent.products.alpine.info_technice.img_1.src" :alt="this.$parent.products.alpine.info_technice.img_1.alt">
                        <img :src="this.$parent.products.alpine.info_technice.img_2.src" :alt="this.$parent.products.alpine.info_technice.img_2.alt">
                    </div>
                    <div class="product-info__specifications" v-html="this.$parent.products.alpine.info_technice.specificatii"></div>
                </div>
                <div class="product-links">
                    <a :href="this.$parent.products.alpine.pliant.href" target="_blank">
                        Descarca pliantul
                        <img :src="this.$parent.products.alpine.pliant.src" :alt="this.$parent.products.alpine.pliant.alt">
                    </a>
                    <a :href="this.$parent.products.alpine.pliant_instalare.href" target="_blank">
                        Ghid instalare
                        <img :src="this.$parent.products.alpine.pliant_instalare.src" :alt="this.$parent.products.alpine.pliant_instalare.alt">
                    </a>
                </div>
            </div>
        </section>
        <!-- END SECTION PROFIL ALPINE -->
        
    </div>
</template>
<script>
export default {
  data() {
    return {
      name: "gerardProducts",
      options: {
        arrows: true,
        dots: true,
        speed: 750,
        fade: true,
        pauseOnHover: true,
        infinite: true,
        autoplay: true
      }
    };
  }
};
</script>
<style lang="scss">
@import "../../assets/css/_variables.scss";

.page-gerard {
  .product {
    img {
      width: auto;
    }
    &-description {
      margin-bottom: 2rem;
      span {
        color: $primary-color;
      }
    }
    &-colors {
      display: flex;
      flex-wrap: wrap;
      margin-bottom: 2rem;
      li {
        margin: 1rem;
        text-align: center;
      }
      img {
        border-radius: 50%;
        display: block;
        margin-bottom: 1rem;
      }
      span {
        font-weight: $medium;
        font-size: 0.875rem;
      }
    }
    &-info {
      display: flex;
      align-items: center;
      margin-bottom: 2rem;
      &__images {
        margin-right: 2rem;
        width: 300px;
        img {
          display: inline-block;
          &:first-child {
            border-radius: 50%;
            margin-bottom: 1rem;
          }
          &:last-child {
            width: 300px;
          }
        }
      }
      &__specifications {
        width: calc(100% - 2rem);
        li {
          border-bottom: 1px solid $light-gray;
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 1rem 1rem 1rem 2rem;
          position: relative;
          &:before {
            content: "";
            background-color: $secondary-color;
            border-radius: 50%;
            display: block;
            margin-right: 10px;
            position: absolute;
            top: 50%;
            left: 0;
            margin-top: -5px;
            height: 10px;
            width: 10px;
          }
        }
      }
    }
    &-links {
      display: flex;
      text-align: center;
      a:first-child {
        margin-right: 2rem;
      }
      img {
        margin-top: 1rem;
      }
    }
    .link {
      margin-bottom: 2rem;
    }
  }
}

/*=============================================
=            RESPONSIVE            =
=============================================*/
@media (max-width: 991.98px) {
  .page-gerard {
    .agile {
      img {
        width: 100%;
      }
    }
    .product-info {
      flex-wrap: wrap;
      &__images {
        margin: 0 0 1rem 0;
        text-align: center;
        width: 100%;
        img:first-child {
          margin: 0 1rem 0 0;
        }
      }
    }
  }
}
@media (max-width: 767.98px) {
  .page-gerard {
    .product-colors {
      justify-content: center;
    }
    .product-info {
      &__images {
        img:first-child {
          margin: 0 0 1rem 0;
        }
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/layouts/gerardProducts.vue